import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../theme';

export interface Props {
	type?: 'success' | 'fail';
	title: string;
	text: string;
}

const StatusMessage: React.FC<Props> = props => {
	const { type, title, text } = props;
	const { StatusMessage: css } = useTheme('StatusMessage');

	return (
		<div
			className={cn(css.statusMessage, {
				[css.statusMessage_success]: type === 'success',
				[css.statusMessage_fail]: type === 'fail'
			})}
		>
			<h3 className={css.statusMessage__title}>{title}</h3>
			<p className={css.statusMessage__text}>{text}</p>
		</div>
	);
};

export default StatusMessage;
